import { useTranslation } from "react-i18next";

/**
 * Institutional partners strip — public pages.
 * Uses ONLY the official logos delivered by the client (/brand/client/*).
 * Missing logos (Valoriza, Xunta) are intentionally NOT rendered.
 */

const PARTNERS = [
  {
    key: "eu",
    src: "/brand/client/eu-nextgen.png",
    label: "NextGenerationEU",
    subKey: "common.eu_funded_short",
    href: "https://next-generation-eu.europa.eu/",
  },
  {
    key: "prtr",
    src: "/brand/client/prtr.png",
    label: "PRTR",
    subKey: "partners.prtr_sub",
    href: "https://planderecuperacion.gob.es/",
  },
  {
    key: "segittur",
    src: "/brand/client/segittur.png",
    label: "SEGITTUR",
    subKey: "partners.segittur_sub",
    href: "https://www.segittur.es/",
  },
  {
    key: "mancomunidade",
    src: "/brand/client/mancomunidade.png",
    label: "Mancomunidade do Salnés",
    subLiteralGl: "Cambados · Meis · Vilanova de Arousa",
    subLiteralEs: "Cambados · Meis · Vilanova de Arousa",
    href: "https://mancomunidadedosalnes.gal/",
  },
  {
    key: "pid",
    src: "/brand/client/pid.png",
    label: "Destinos Turísticos Inteligentes",
    subLiteralGl: "Plataforma PID",
    subLiteralEs: "Plataforma PID",
    href: "https://www.destinosinteligentes.es/",
  },
];

function Partner({ p, dark, t, i18n }) {
  const lang = i18n.language?.startsWith("es") ? "es" : "gl";
  const sub = p.subKey
    ? t(p.subKey)
    : lang === "es"
      ? p.subLiteralEs
      : p.subLiteralGl;
  return (
    <a
      href={p.href}
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center gap-3 min-w-[200px] hover:opacity-100 opacity-95 transition-opacity"
      data-testid={`partner-${p.key}`}
      title={p.label}
    >
      <span
        className={`h-11 shrink-0 flex items-center justify-center bg-white rounded px-2 py-1 ${
          dark ? "" : "border hairline"
        }`}
      >
        <img
          src={p.src}
          alt={p.label}
          className="h-8 w-auto object-contain"
          loading="lazy"
        />
      </span>
      <div className="leading-tight">
        <div
          className={`font-serif text-[13px] ${
            dark ? "text-white" : "text-salnes-ink"
          }`}
        >
          {p.label}
        </div>
        {sub && (
          <div
            className={`text-[10px] uppercase tracking-[0.16em] ${
              dark ? "text-white/50" : "text-salnes-stone"
            }`}
          >
            {sub}
          </div>
        )}
      </div>
    </a>
  );
}

export default function PartnersStrip({ variant = "public" }) {
  const { t, i18n } = useTranslation();
  const dark = variant === "dark";
  return (
    <div
      className={`w-full border-y hairline ${
        dark ? "bg-salnes-ink text-white" : "bg-white"
      }`}
      data-testid="partners-strip"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 py-6 flex items-center gap-6 lg:gap-10 overflow-x-auto">
        {PARTNERS.map((p) => (
          <Partner key={p.key} p={p} dark={dark} t={t} i18n={i18n} />
        ))}
      </div>
    </div>
  );
}
